import { useEffect, useState } from 'react';
import { arenaScadutaMaAttiva, effectiveEndsAt } from '../utils/tournament-helpers';

/** Il minimo che serve per sapere se il tempo e' finito. */
interface ArenaConScadenza {
  status: string;
  startsAt: string;
  endsAt: string | null;
  durationMinutes: number;
}

/**
 * `arenaScadutaMaAttiva` che si accorge da sola dello scadere.
 *
 * Senza questo battito la banda direbbe la verita' solo a chi apre la pagina
 * dopo il termine: chi era gia' li' resterebbe a leggere «cerco un avversario»
 * fino al primo ridisegno per altri motivi.
 *
 * UN SOLO `setTimeout`, sul traguardo, e poi niente — mai un `setInterval`: le
 * animazioni e i timer perpetui su superfici sempre montate sono il difetto
 * ricorrente di questa app (vedi i test del moto perpetuo), e qui c'e' un solo
 * istante in cui qualcosa cambia. La clessidra accanto batte gia' al secondo
 * per conto suo: non serve un secondo orologio.
 *
 * ⚠️ L'effetto dipende dalla STRINGA della scadenza, non dall'oggetto arena:
 * quello cambia identita' a ogni classifica — una ogni due secondi — e il timer
 * si riarmerebbe per sempre senza scattare mai.
 *
 * Una scheda in secondo piano lo fa scattare in ritardo, e non e' un problema:
 * il valore di ritorno si ricalcola a ogni render da `Date.now()`, il timer
 * serve solo a provocare quel render.
 */
export function useArenaScaduta(arena: ArenaConScadenza | null | undefined): boolean {
  const [, setBattito] = useState(0);
  const fine = arena && arena.status === 'active' ? effectiveEndsAt(arena) : null;

  useEffect(() => {
    if (!fine) return;
    /* +250ms di margine: allo scoccare esatto `Date.now()` puo' essere ancora
       un filo indietro, e il render sarebbe speso per niente. */
    const attesa = new Date(fine).getTime() - Date.now() + 250;
    if (Number.isNaN(attesa) || attesa <= 0) return;
    const timer = setTimeout(() => setBattito((b) => b + 1), attesa);
    return () => clearTimeout(timer);
  }, [fine]);

  return arena ? arenaScadutaMaAttiva(arena) : false;
}
